import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { alpha, Box, IconButton, Typography, useTheme } from '@mui/material';

interface AnimatedBackButtonProps {
  onClick: () => void;
  text?: string;
}

const AnimatedBackButton = ({
  onClick,
  text = 'Back',
}: AnimatedBackButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      mb={4}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateX(-6px)',
        },
      }}
      onClick={onClick}
    >
      <IconButton
        size="medium"
        sx={{
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          color: theme.palette.primary.main,
          mr: 2,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.15),
            transform: 'scale(1.05)',
          },
          transition: 'all 0.3s ease-in-out',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography
        variant="body1"
        color="primary"
        sx={{
          fontWeight: 500,
          userSelect: 'none',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AnimatedBackButton;
